import { comm } from '../comm';
import { store } from '../stores/mainStore';
import { integration } from '../integration';

if(true){//window.location.port === '3000' || window.location.hash === '#dev'){
	window.commands = [];
	window.WrapperApp = {

		postMessage: (message) => {

			// if(!(window.location.port === '3000' || window.location.hash === '#dev')) {
			// 	if(store.wrapperCommandProcessing === false) {
			// 		store.wrapperCommandProcessing = true;
			// 		window.location.href = "uniwebview://"+message;
			// 	} else
			// 	 {
			// 		window.commands.push(message);
			// 	}
			// } else
			// {
				if(message === 'fblogin'){

					new Promise((resolve, reject) => {
						FB.getLoginStatus(function(response){
							if (response.status === 'connected') {
								resolve([response.authResponse.userID, response.authResponse.accessToken, response.authResponse.data_access_expiration_time]);
							} else {
								FB.login((response) => {
									if (response.status === 'connected') {
										resolve([response.authResponse.userID, response.authResponse.accessToken, response.authResponse.data_access_expiration_time]);
									} else {
										integration.postAnalyticsEvent('facebook_not_authorized');
										reject('user did not authorize facebook');
									}
								}, {scope: 'user_friends'});
							}
						})
					}).then(([id, token, expiration]) => {
						integration.postAnalyticsEvent('facebook_authorized');
						facebookLogin(id,token,expiration);
					});
				} else if(message === 'fblogout'){
					facebookLogout();
				} else if(message === 'invite'){
					let accessToken = store.user.facebook.localData.token;
					FB.ui({method: 'apprequests',
						// action_type: 'RECOMMEND',
						access_token: accessToken,
						message: 'Play Shake It Up Dice Poker with me!'
					}, function(response){
						//console.log("App Request",response);
						if(response && response.to){
							response.to.forEach((id) => {
								comm.InviteFriend('fb',id);
							})
						}
					});
				} else {
					//console.log(message);
				}
			//}

		}
	}
// } else {
// 	console.log = function(){
// 		WrapperApp.postMessage(JSON.stringify(arguments));
// 	}
// 	console.warn = function(){
// 		WrapperApp.postMessage(JSON.stringify(arguments));
// 	}
// 	console.error = function(){
// 		WrapperApp.postMessage(JSON.stringify(arguments));
// 	}
}

export function handleFacebookLogout(){
	// localStorage.removeItem('facebookLoginData');
	facebookLogout();
}

export function handleFacebookLogin(data){
	//console.log(data);
	// sample data:
	// {
	// 	"token": "EAAaxNMEGUW8BAPvbMRB5TPF6sj9hYVRLsbklwvE7WafOZAuwdIubZBUZCdpv9YDZC2mzekIo5yk8cQJPDoZBJbt3CAfiTKrFmivI4CSzI4EpXlehvDBGKGsA827xdgvjXY57Eea8TUM2mdCkD3ZAKoYQ11PrZB3DbaCEUlYlMzZAkE8gBxot7ZCPOdAMkE25HAliBP4X4psnjiQ7Np4XowYX2aqqTYPiRZBAMluARrB6rmUAZDZD",
	// 	"userId": "178790713206785",
	// 	"expires": 1589129472181,
	// 	"permissions": ["user_birthday", "email", "user_friends", "public_profile"],
	// 	"declinedPermissions": []
	// }
	// setPersistentStorage('facebookLoginData', JSON.stringify(data));
	// WrapperApp.postMessage('localStorage set '+data.token+data.userId);
	facebookLogin(data.UserId, data.TokenString, data.ExpirationTime);

	// window.WrapperApp.postMessage('calling handleFacebookLogin UserId:'+data.UserId+'TokenString:'+data.TokenString+'ExpirationTime:'+data.ExpirationTime);

}

function facebookLogin(id, token, expiration){
	// window.WrapperApp.postMessage('id: '+id+' token: '+token+' exp '+expiration);
	// window.store.debugArray.push(`99 fb message handled ${id} ${token}`)
	store.user.facebook.update(id, token, expiration);
	store.user.login()
	.then(() => {
		store.user.updateHearts()
		.then(() => {
			if(store.user.hearts + 5 === store.user.animateToHearts){
				//use the purchase dialog to animate the hearts gained.
				store.purchaseComplete = true;
			}
		});
	});
}

function facebookLogout(){
	localStorage.removeItem('fbUserId');
	store.user.facebook.disconnect();
}
